module.exports = __webpack_public_path__ + "img/morning-background.7e687a55.png";